import { Fragment, ReactElement, useMemo } from 'react';
import {
  MetricAuthorizations,
  ResearchRegisterAuthorizations,
  ResponsibleAuthorizations,
  TypeOperationAuthorizations,
  PracticeResearchAuthorizations,
  TypePracticeAuthorizations,
} from 'shell/authorizations/practice';
import { useActionAuthorization } from 'shell/hooks/use-action-authorization';
import ServiceTableCollapse from './service-table-collapse';
import UnavailabilityManagementTableCollapse from './unavailability-table-collapse';
import { useUserProfile } from 'shell/hooks/use-user-profile';

interface NestedItemsPracticeProps {
  link: string;
  onSubItemClick?: () => void;
}

const NestedItemsPractice = ({ link, onSubItemClick }: NestedItemsPracticeProps): ReactElement => {
  const actions = useActionAuthorization({
    ricercaRegistro: ResearchRegisterAuthorizations,
    ricercaTipoPratica: TypePracticeAuthorizations,
    ricercaTipoOperazione: TypeOperationAuthorizations,
    ricercaResponsabile: ResponsibleAuthorizations,
    ricercaMetrica: MetricAuthorizations,
    aperturaPratica: PracticeResearchAuthorizations,
    stampaPratica: PracticeResearchAuthorizations,
  });

  const { userProfile } = useUserProfile();

  const gestioneTabelleSistema = userProfile.datiLogin?.profile?.feature?.sistema;

  const visibilityServiceTable = useMemo(() => {
    return (
      (!actions.ricercaRegistro &&
        !actions.ricercaTipoPratica &&
        !actions.ricercaTipoOperazione &&
        !actions.ricercaResponsabile &&
        !actions.ricercaMetrica) ||
      gestioneTabelleSistema === '0'
    );
  }, [actions, gestioneTabelleSistema]);

  const visibilityManagementTable = useMemo(() => {
    return !actions.aperturaPratica && !actions.stampaPratica;
  }, [actions]);

  return (
    <Fragment>
      {visibilityManagementTable ? undefined : (
        <UnavailabilityManagementTableCollapse
          link={link}
          onSubItemClick={onSubItemClick}
          active={actions || {}}
        />
      )}
      {visibilityServiceTable ? undefined : (
        <ServiceTableCollapse link={link} onSubItemClick={onSubItemClick} active={actions || {}} />
      )}
    </Fragment>
  );
};

NestedItemsPractice.displayName = 'nested Items practice component';

export default NestedItemsPractice;
